export default class PatternDropdownViewModel {
    public id: number = 0;
    public label: string = '';
    public numberOfWeeks: number = 0;
}